import { StyleSheet } from 'react-native';
import { brand, neutrals } from '../../../theme/colors';

export const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 10,
  },
  grey: {
    backgroundColor: neutrals.black,
    opacity: 0.2,
  },
  darkBlue: {
    backgroundColor: brand.main.water,
    opacity: 0.6,
  },
  lightBlue: {
    backgroundColor: brand.main.water,
    opacity: 0.2,
  },
});
